import { useState, useEffect } from "react";
import axiosConfig from '../../axiosConfig';
import Header from "../../Header/Header";
import { useParams } from "react-router-dom";


const ResetPass=()=>{
    const { username } = useParams();
    const [newpassword,setnewPassword] = useState("");
    const [validUpper, setValidUpper] = useState(false);
    const [validLower, setValidLower] = useState(false);
    const [validDigit, setValidDigit] = useState(false);
    const [validSpecial, setValidSpecial] = useState(false);
    const [validLength, setValidLength] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [err_msg, setErrMsg] = useState("");

    useEffect(() => {
        generateRandomString();
    }, []);

    useEffect(() => {
        setValidUpper(/[A-Z]/.test(newpassword));
        setValidLower(/[a-z]/.test(newpassword));
        setValidDigit(/\d/.test(newpassword));
        setValidSpecial(/[^A-Za-z0-9]/.test(newpassword));
        setValidLength(newpassword.length >= 6);
    }, [newpassword]);

        const generateRandomString = () => {
                const length = 8;
                const lowerCaseChars = 'abcdefghijklmnopqrstuvwxyz';
                const upperCaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
                const numberChars = '0123456789';
                const specialChars = '!@#$%^&*()_+-=[]{}|;:,.<>?';
    
                const allChars = lowerCaseChars + upperCaseChars + numberChars + specialChars;
                let password = '';
    
                // Ensure at least one character of each type
                password += getRandomChar(lowerCaseChars);
                password += getRandomChar(upperCaseChars);
                password += getRandomChar(numberChars);
                password += getRandomChar(specialChars);
    
                // Fill up the rest of the password with random characters
                for (let i = password.length; i < length; i++) {
                    password += getRandomChar(allChars);
                }
    
                // Shuffle the characters in the password
                password = shuffleString(password);
    
                setnewPassword(password);
            };
    
    const getRandomChar = (characterSet) => {
        const randomIndex = Math.floor(Math.random() * characterSet.length);
        return characterSet[randomIndex];
      };
    
    const shuffleString = (str) => {
        const arr = str.split('');
        for (let i = arr.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [arr[i], arr[j]] = [arr[j], arr[i]];
        }
        return arr.join('');
      };



    const handleForm = (e) => {
        e.preventDefault();

        // client-side validation
        const errors = {};
        if (!newpassword) errors.newpassword = 'New password is required';
        if (!validLength || !validUpper || !validLower || !validDigit || !validSpecial) {
            errors.newpassword = 'Password does not meet the requirements';
        }

        if (Object.keys(errors).length > 0) {
            setErrMsg(errors.newpassword);
            return;
        }

        const obj = {username: username, newpassword:newpassword};
        axiosConfig.post("/appuser/resetpass",obj).then((rsp)=>{
            navigator.clipboard.writeText(newpassword)
            alert(`${rsp.data.msg} & new password copied to clipboard`);
            window.location.href = "/user-passreset";

        }).catch((err) => {
            if (err.response && err.response.status === 422) {
                const data = err.response.data || {};
                if (typeof data.err === 'string') {
                    setErrMsg(data.err);
                    alert(data.err);
                } else {
                    setErrMsg('Validation error');
                    alert(data.msg || 'Validation error');
                }
            } else {
                setErrMsg('Network or server error');
                alert('Network or server error');
            }
        });
    }

    return (
    <div><Header title=""/>
        <div class="app-content content" style={{ backgroundColor: "azure" }}>
            <div class="content-overlay"></div>
            <div class="content-wrapper" >
                <div class="content-header row">
                </div>
                <div class="content-body">

                    <div class="row">
                        <div class="col-3"></div>
                        <div class="col-6 box-shadow-2 p-0">


                            <div class="card border-grey border-lighten-3 m-0" >
                                <div className="card-header border-0 pb-0">
                                    <div className="card-title text-center">
                                    <img style={{width:'13%',height:'0%'}} src="/app-assets/images/logo/app-user.png" alt="user logo"/>
                                    </div>
                                    <h6 className="card-subtitle line-on-side text-muted text-center font-medium-5 pt-2"><span> Reset Password</span>
                                    
                                    </h6>
                                    <div className="card-title text-center">
                                    
                                    </div>
                                    
                                </div>
                                <div className="card-content" >
                                    <div className="card-body">
                                        <form className="form-horizontal" onSubmit={handleForm} noValidate>
                                            
                            
                                                <div className="row">
                                                    <div className="col-9 col-sm-9 col-md-9">
                                                        <fieldset className="form-group position-relative has-icon-left">
                                                            <input type={showNewPassword ? 'text' : 'password'} disabled name="password" id="password" className={`form-control ${err_msg ? 'is-invalid' : ''}`} value={newpassword} placeholder="New Password" tabIndex={3} required />
                                                            <div className="form-control-position">
                                                                <i className="la la-key" />
                                                            </div>
                                                            <div
                                                                role="button"
                                                                tabIndex={0}
                                                                title="Hold to reveal password"
                                                                aria-label="Hold to reveal password"
                                                                style={{position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: showNewPassword ? '#0f5132' : '#495057'}}
                                                                onMouseDown={() => setShowNewPassword(true)}
                                                                onMouseUp={() => setShowNewPassword(false)}
                                                                onMouseLeave={() => setShowNewPassword(false)}
                                                                onTouchStart={() => setShowNewPassword(true)}
                                                                onTouchEnd={() => setShowNewPassword(false)}
                                                                onKeyDown={(e) => { if (e.key === ' ' || e.key === 'Enter') setShowNewPassword(true); }}
                                                                onKeyUp={(e) => { if (e.key === ' ' || e.key === 'Enter') setShowNewPassword(false); }}
                                                            >
                                                                <i className={showNewPassword ? 'la la-eye-slash' : 'la la-eye'} style={{fontSize: '1.05rem'}} />
                                                            </div>
                                                            <div className="help-block font-small-3" />
                                                            <span className="text-danger">{err_msg ? err_msg : ''}</span>
                                                        </fieldset>
                                                        <div className="mt-2">
                                                            <ul className="list-unstyled mb-0 small">
                                                                <li className={validUpper ? 'text-success' : 'text-danger'}><i className={validUpper ? 'la la-check-circle mr-1' : 'la la-times-circle mr-1'}></i> At least one uppercase letter</li>
                                                                <li className={validLower ? 'text-success' : 'text-danger'}><i className={validLower ? 'la la-check-circle mr-1' : 'la la-times-circle mr-1'}></i> At least one lowercase letter</li>
                                                                <li className={validDigit ? 'text-success' : 'text-danger'}><i className={validDigit ? 'la la-check-circle mr-1' : 'la la-times-circle mr-1'}></i> At least one digit</li>
                                                                <li className={validSpecial ? 'text-success' : 'text-danger'}><i className={validSpecial ? 'la la-check-circle mr-1' : 'la la-times-circle mr-1'}></i> At least one special character</li>
                                                                <li className={validLength ? 'text-success' : 'text-danger'}><i className={validLength ? 'la la-check-circle mr-1' : 'la la-times-circle mr-1'}></i> Minimum 6 characters</li>
                                                            </ul>
                                                        </div>
                                                        </div>
                                                        <div className="col-3 col-sm-3 col-md-3 text-nowrap"> <i className="la la la-copy btn btn-outline-info btn-sm" onClick={()=> {navigator.clipboard.writeText(newpassword)}} />&nbsp;<i className="la la-refresh btn btn-info btn-sm" onClick={()=> generateRandomString()} /></div>
                                                    
                                                    </div>
                                                    
                                                
                                            

                                            

                                            <div class="pl-0">
                                                <button type="submit" className="btn btn-info btn-block" onClick={()=> {navigator.clipboard.writeText(newpassword)}}><i className="la la-user" />
                                                            Reset Password</button>
                                                    

                                            </div>

                                        </form>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                </div>
            </div>
        </div>
        </div>


    )
}
export default ResetPass;